import * as React from 'react';
import Svg, { Circle, Rect, SvgProps } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

export const CasinoProductIcon = (props: SvgProps & { fill?: string }) => (
    <Svg width={16} height={16} {...props} fill="none" viewBox="0 0 16 16">
        <Rect
            x={1.89996}
            y={1.90002}
            width={12.2}
            height={12.2}
            rx={2.61429}
            stroke={props.fill || ds.colorValue.icon.primary}
            strokeWidth={1.25}
        />
        <Circle cx={5.33334} cy={5.33331} r={1} fill={props.fill || ds.colorValue.icon.primary} />
        <Circle cx={5.33334} cy={10.6667} r={1} fill={props.fill || ds.colorValue.icon.primary} />
        <Circle cx={8} cy={8} r={1} fill={props.fill || ds.colorValue.icon.primary} />
        <Circle cx={10.6667} cy={5.33331} r={1} fill={props.fill || ds.colorValue.icon.primary} />
        <Circle cx={10.6667} cy={10.6667} r={1} fill={props.fill || ds.colorValue.icon.primary} />
    </Svg>
);
